__turbopack_context__.v({
  "actionsRow": "ProjectItemDetail-module__3cIE0q__actionsRow",
  "badgesRow": "ProjectItemDetail-module__3cIE0q__badgesRow",
  "nonShrinking": "ProjectItemDetail-module__3cIE0q__nonShrinking",
  "pillContainer": "ProjectItemDetail-module__3cIE0q__pillContainer",
  "pillText": "ProjectItemDetail-module__3cIE0q__pillText",
  "titleBox": "ProjectItemDetail-module__3cIE0q__titleBox",
  "titleMetaRow": "ProjectItemDetail-module__3cIE0q__titleMetaRow",
});
